function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
_toConsumableArray(document.querySelectorAll('.js-default-gallery')).forEach(function (block) {
  // Create a new modal
  var Modal = new window.ModalController({
    removeFromDOM: false
  });
  // The gallery list
  var list = block.querySelector('.js-default-gallery__list');
  // The slider items
  var items = _toConsumableArray(list.children);
  // Find the modal content
  var content = block.querySelector('.js-default-gallery__modal');
  // Find the slider
  var slider = content.querySelector('.js-default-gallery__slider');
  // Find the slides
  var slides = _toConsumableArray(slider.children);
  var removeVideos = function removeVideos() {
    _toConsumableArray(content.querySelectorAll('iframe')).forEach(function (iframe) {
      iframe.parentNode.removeChild(iframe);
    });
  };

  // When the modal opens, lock the scroll
  Modal.on('open', function () {
    window.ScrollLocker.lock();
  });

  // When the modal closes, unlock the scroll
  Modal.on('close', function () {
    window.ScrollLocker.unlock();
    removeVideos();
  });

  // Append the modal content to the modal
  Modal.append(content);

  // Create a new slider
  slider.tns = window.tns({
    container: slider,
    items: 1,
    slideBy: 'page',
    autoplay: false,
    controls: true,
    nav: false
  });

  // When the slide changes remove the videos
  slider.tns.events.on('indexChanged', removeVideos);

  // Loop through each item
  items.forEach(function (item, i) {
    // Find the action button
    var action = item.querySelector('.js-default-gallery__action');

    // Open the modal when the action button is clicked
    action.addEventListener('click', function () {
      Modal.open();
      slider.tns.goTo(i);

      // If the slides[i] has a data-video, simulate a click event on it
      var video = slides[i].querySelector('[data-video]');

      // If there is no video, return
      if (!video) return;

      // Simulate a click event on the video
      video.dispatchEvent(new Event('click'));
    });
  });
});